import { Empty } from 'components/LottieFiles';
import BadgeItem from './BadgeItem';
import { Grid, SeeAll, Wrapper } from './BadgesCard.styles';
import { BadgesCardProps } from './BadgesCard.types';
import NoImage from 'assets/images/noImage.png';
import { useTranslation } from 'react-i18next';

const BadgesCard = ({
  badges,
  handleSeeAll,
  ...rest
}: BadgesCardProps): JSX.Element => {
  // const getBadgeImage
  const { t } = useTranslation();

  return (
    <Wrapper {...rest}>
      <SeeAll>
        <p>{t('meritbadges')}</p>
        <button onClick={handleSeeAll}>{t('seeAll')}</button>
      </SeeAll>
      {badges.length > 0 ? (
        <Grid>
          {badges.map((badge: any, index) => {
            const img = badge?.media[0]?.location;
            return (
              <BadgeItem
                key={badge + index}
                badgeImage={img || NoImage}
                badgeName={badge?.name}
                badgeDescription={badge?.description}
              />
            );
          })}
        </Grid>
      ) : (
        <Empty />
      )}
    </Wrapper>
  );
};

export default BadgesCard;
